import { LazyLoader, Modal } from '@bp/ui-components';
import { CourseForm } from 'components/Courses/forms/CourseForm';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';

type CourseModalProps = {
  isOpen: boolean;
  courseUuid: string | null;
  schoolYearUuid: string;
  page: 'courses' | 'institution';
  onClose: () => void;
};

export const CourseModal = ({ isOpen, courseUuid, schoolYearUuid, page, onClose }: CourseModalProps) => {
  const { t } = useTranslation();

  const headlines: string[] = [
    courseUuid && courseUuid !== '' ? t('courses.editCourse') : t('courses.addCourse'),
    t('courses.membersOverview'),
    t('courses.collaborationOverview'),
  ];

  const [headline, setHeadline] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  function handleStep(step: number) {
    setHeadline(headlines[step]);
  }

  return (
    <Modal
      isOpen={isOpen}
      loading={loading}
      onRequestClose={() => {
        setHeadline('');
        onClose();
      }}
      title={headline}
      padding={'m'}
    >
      <Suspense fallback={<LazyLoader embedded forceHeight='60vh' />}>
        <CourseForm
          courseUuid={courseUuid}
          schoolYearUuid={schoolYearUuid}
          page={page}
          onStep={handleStep}
          onLoad={setLoading}
          onClose={() => {
            setHeadline('');
            onClose();
          }}
        />
      </Suspense>
    </Modal>
  );
};
